export enum CatalogueItemType {
    Product = "Product",
    Modifier = "Modifier",
}
